module.exports = __webpack_public_path__ + "static/img/nh-university-hr-system.460416d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/nh-university-hr-system.jpg
// module id = MK4A
// module chunks = 0